import React, { useState, useEffect } from 'react';
import { Box, Typography, Collapse, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { chatAPI } from '../../utils/api';
import UsageLimits from './UsageLimits';
import { useAuth } from '../../contexts/AuthContext';

const ChatLimits = ({ variant = 'standard' }) => {
  const [limits, setLimits] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }
    
    const fetchLimits = async () => {
      try {
        setLoading(true);
        const response = await chatAPI.getChatLimits();
        if (response.data && response.data.success && response.data.data) {
          setLimits(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching chat limits:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLimits();
  }, [isAuthenticated]);

  if (!isAuthenticated || loading || !limits) {
    return null;
  }

  const { chat_turns } = limits;
  if (!chat_turns || typeof chat_turns.used !== 'number' || typeof chat_turns.limit !== 'number') {
    return null;
  }

  if (variant === 'compact') {
    return (
      <Box sx={{ mb: 2 }}>
        <UsageLimits
          title="Chat Turns"
          used={chat_turns.used}
          limit={chat_turns.limit}
          tooltip="Daily limit for conversations with FashionMate AI"
          variant="compact"
        />
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        size="small"
        onClick={() => setExpanded(!expanded)}
        endIcon={expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        variant="text"
        sx={{ mb: 1, textTransform: 'none', color: 'text.secondary' }}
      >
        <Typography variant="body2">
          {expanded ? 'Hide Usage Limits' : 'Show Usage Limits'}
        </Typography>
      </Button>
      
      <Collapse in={expanded}>
        <Box sx={{ mt: 1 }}>
          <UsageLimits
            title="Chat Turns"
            used={chat_turns.used}
            limit={chat_turns.limit}
            tooltip="Daily limit for conversations with FashionMate AI"
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default ChatLimits;
